import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.ailabbet.com";

interface SeoHeadProps {
  title: string;
  description: string;
  path: string; // e.g. "/about"
  type?: "website" | "article";
  noIndex?: boolean;
  jsonLd?: object | object[];
}

/**
 * Per-route SEO head. Sets title, description, canonical, og:* and optional
 * JSON-LD. Canonical is intentionally NOT set in index.html so this is the
 * single source per route.
 */
const SeoHead = ({
  title,
  description,
  path,
  type = "website",
  noIndex,
  jsonLd,
}: SeoHeadProps) => {
  const url = `${SITE_URL}${path}`;
  const ldArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {ldArray.map((ld, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(ld)}
        </script>
      ))}
    </Helmet>
  );
};

export default SeoHead;
